<template>
  <div class="ChatRate">
    <div class="">
      <h5 class="intro-title text-xl">{{ $t('AiHome.chat.rating_title') }}</h5>
    </div>

    <Table :columns="tableList.columns"
      :data="tableList.datas">
        <template slot="actionsLabel">
          <th class="whitespace-no-wrap text-center">{{ $t('AiHome.chat.updated_at') }}</th>
          <th class="whitespace-no-wrap text-center">{{ $t('AiHome.chat.scene_topic') }}</th>
          <th class="whitespace-no-wrap text-center">{{ $t('AiHome.chat.chat_settings') }}</th>
        </template>
        <!-- slot-scope="props" -->
        <template slot="actionsBtn">
          <td :data-th="$t('AiHome.chat.updated_at')">
            2024/05/20　20:30:05
          </td>
          <td :data-th="$t('AiHome.chat.scene_topic')">
            {{ $t('AiHome.chat.sample_scene_topic') }}
          </td>
          <td :data-th="$t('AiHome.chat.chat_settings')">
            {{ $t('AiHome.chat.sample_voice_setting') }}
          </td>
        </template>
    </Table>

    <div class="d-flex text-center list-title mb-3">
      <div class="col-2 p-2">{{ $t('AiHome.chat.sentence_score') }}</div>
      <div class="col-10 p-2">{{ $t('AiHome.chat.chat_content') }}</div>
    </div>
    <div class="d-flex">
      <div class="col-2 text-center bg-white d-flex align-items-center justify-content-center">
        <div>
          <p class="font-bold">Score</p>
          <p class="font-bold score">88</p>
        </div>
      </div>
      <div class="col-10 bg-white">
        <div class="d-flex">
          <div class="text-white ai p-2 text-center d-flex align-items-center justify-content-center">AI</div>
          <div class="text-white icon-w p-2 text-center d-flex align-items-center justify-content-center"><img src="@/assets/image/ai/btn_AItalk_play_perple.png"></div>
          <div class="flex-1 d-flex align-items-center">
            <p>Do you like to chat with your friends on the phone?</p>
          </div>
        </div>
        <div class="d-flex">
          <div class="text-white you p-2 text-center d-flex align-items-center justify-content-center">YOU</div>
          <div class="text-white icon-w p-2 text-center d-flex align-items-center justify-content-center"><img src="@/assets/image/ai/btn_AItalk_voice.png"></div>
          <div class="flex-1 d-flex align-items-center">
            <p>Yes, I like to chat with my friends on the phone. We often talk about food and movies.We also like to share about our days.</p>
          </div>
        </div>
      </div>
    </div>

    <div class="d-flex align-items-center justify-content-center w-100 mt-3">
      <a class="btn-submit mx-auto d-inline-block">{{ $t('AiHome.chat.continue_conversation') }}</a>
    </div>
  </div>
</template>

<script>
  import Table from '@/components/AiHelper/table'
  export default {
    name: 'ChatRate',
    components: {
      Table
    },
    data () {
      return {
        tableList: {
          columns: [
          ],
          datas: [{}]
        }
      }
    },
    methods: {
    }
  }
</script>
<style lang="scss" scoped>
@import "@/assets/styles/color.scss";
.ChatRate {
  padding: 1rem;
  @media (min-width: 640px) {
    padding: 1.5rem;
  }
  .intro-title {
    color: $main-color;
    font-weight: 700;
    margin-bottom: 0.75rem;
    @media (min-width: 640px) {
      margin-right: 0.5em;
    }
  }
  .list-title {
    background: rgba(90, 93, 155, 1);
    color: white;
  }
  .score {
    font-size: 3em;
  }
  .icon-w {
    width: 60px;
  }
  .ai {
    width: 60px;
    background: rgba(90, 93, 155, 1);
  }
  .you {
    width: 60px;
    background: rgba(226, 128, 73, 1);

  }
}

</style>
